import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/common.css'
import './assets/css/style.css'
import './assets/css/style2.css'
import './assets/js/rem2'
import Vant from 'vant'
import 'vant/lib/index.css'
import common from '@/assets/js/common'
import { Uploader } from 'vant'

Vue.config.productionTip = false
Vue.prototype.$common = common
Vue.use(Vant)
Vue.use(Uploader)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
